import {
    HTTPBatchLinkOptions,
    HTTPLinkOptions,
    httpBatchLink,
    httpLink,
    splitLink,
    TRPCLink,
} from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';
import { observable } from '@trpc/server/observable';
import { envs } from '../../env';
import type { AppRouter } from '@sapphicsavvy/router';
import { MB_accessTokenUtils } from '@mightybyte/rnw.utils.access-token-utils';
import { signedInContextGlobalFunction } from '../context/SignedInContext';

const trpc = createTRPCReact<AppRouter>({});

function getConfig<T extends boolean>(
    forBatch: T,
): T extends true ? HTTPBatchLinkOptions : HTTPLinkOptions {
    if (forBatch) {
    }
    return {
        url: `${envs.SERVER_URL}/trpc`,
        headers: async () => {
            const accessToken = await MB_accessTokenUtils.getAccessToken(); // TODO: Hovo: We are not refreshing this yet
            return {
                Authorization: accessToken,
            };
        },
    };
}

// Error handling link to catch UNAUTHORIZED errors
const errorLink: TRPCLink<AppRouter> = () => {
    return ({ next, op }) => {
        return observable((observer) => {
            const unsubscribe = next(op).subscribe({
                next(value) {
                    observer.next(value);
                },
                error(err) {
                    // Check if this is an UNAUTHORIZED error (401)
                    if (
                        err?.data?.httpStatus === 401 ||
                        err?.data?.code === 'UNAUTHORIZED'
                    ) {
                        // Sign out the user immediately without refresh token call
                        signedInContextGlobalFunction.signOut?.({
                            skipSignOutRequest: true,
                            showExpiredError: true,
                            makeRefreshTokenCall: false,
                        });
                    }
                    observer.error(err);
                },
                complete() {
                    observer.complete();
                },
            });
            return unsubscribe;
        });
    };
};

const reactTRPCClient = trpc.createClient({
    links: [
        errorLink,
        splitLink({
            condition(op) {
                // check for context property `skipBatch`
                if (op.path === 'user.login') {
                    return true;
                }
                return op.context.skipBatch === true;
            },
            // when condition is true, use normal request
            true: httpLink(getConfig(false)),
            // when condition is false, use batching
            false: httpBatchLink(getConfig(true)),
        }),
    ],
});

export { trpc, reactTRPCClient };
